module.exports = {
  PENDING: 'pending',
  SENT: 'sent',
  UNSENT: 'unsent',
  RECEIVED: 'received',
};
